<template>
  <div class="index_header_box">
    <div class="left">
      <img
        @click="LogoClickHomne"
        style="cursor: pointer;"
        class="company"
        src="../assets/image/company_logo.png"
        alt
      />
    </div>
    <div class="right">
      <img class="logo_setting" @click="settingClick" src="../assets/image/icon_sz@2x.png" alt />
      <!-- @mouseover="isSelectShow = true" -->
      <!-- @mouseout="isSelectShow = false" -->
      <img
        class="header"
        v-if="my_process_avatarUrl=='null' || !my_process_avatarUrl"
        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        @click="headerClick"
        alt
      />
      <img class="header" @click="headerClick" v-else :src="my_process_avatarUrl" alt />
    </div>
    <!-- 头像下拉框 -->
    <transition name="el-zoom-in-top">
      <div v-show="isSelectShow" class="headerSlid">
        <div class="headerInfor">
          <div class="SlidLeft">
            <img
              class="sildHeader"
              v-if="my_process_avatarUrl=='null' || !my_process_avatarUrl"
              src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
              @click="headerClick"
              alt
            />
            <img class="sildHeader" @click="headerClick" v-else :src="my_process_avatarUrl" alt />
          </div>
          <div class="SlidRight">
            <p :title="my_nickname" class="username overFl" v-if="my_nickname">{{my_nickname}}</p>
            <!-- <p class="position">主管/评价人员</p> -->
            <p
              :title="indexInfo.department_name"
              class="position overFl"
              v-if="indexInfo.department_name"
            >{{indexInfo.department_name}}</p>
          </div>
        </div>
        <ul class="userHandle">
          <li class="userHandleItem" @click="goEditUserInfo('1')">
            <img src="../assets/image/ulLogo1.png" alt /> 修改个人信息
          </li>
          <li @click="goEditUserInfo('2')">
            <img src="../assets/image/ulLogo2.png" alt /> 账号安全/密码 
          </li>
          <li @click="goSelectCompany">
            <img
              src="../assets/image/icon_gs@2x.png"
              style="width:15px;padding-left:3px;padding-right:6px"
              alt
            /> 选择企业
          </li>
          <li @click="handleLoginOut">
            <img src="../assets/image/ulLogo4.png" alt /> 安全退出
          </li>
        </ul>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="isSettingShow" class="settingSlid">
        <ul class="userHandle">
          <li class="userHandleItem">系统公告</li>
          <li class="userHandleItem" @click="handleGoHelp">帮助中心</li>
          <li class="userHandleItem">版本日志</li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 头像下拉框是否隐藏
      isSelectShow: false,
      // 设置栏下拉框是否隐藏
      isSettingShow: false,
      tabsCurrent: '1',
      member_id: '',
      token: '',
      company_id: '',
      indexInfo: {},
      avatarUrl: '',
      my_process_avatarUrl: '',
      my_nickname: '',
    }
  },
  methods: {
    handleGoHelp() {
      window.open('https://docs.qq.com/doc/DR3ZtWnFseGh4ZFR')
      this.isSettingShow = false
    },
    goSelectCompany() {
      this.$router.push('/join')
    },
    LogoClickHomne() {
      // this.$router.push('/index')
    },
    // 点击安全退出
    async handleLoginOut() {
      console.log('安全退出')
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/login_out',
      })
      console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // 用户id
      window.localStorage.removeItem('btlh_process_member_id')
      // 用户邮箱
      window.localStorage.removeItem('btlh_process_mail')
      // 用户昵称
      window.localStorage.removeItem('btlh_process_nickname')
      // token
      window.localStorage.removeItem('btlh_process_token')
      this.$router.push('/login')
    },
    goAdmin(val) {
      this.tabsCurrent = 6
      if (val === '成员管理') {
        var query = { type: '1' }
        this.$router.push({
          path: '/admin/organization',
          query,
        })
      } else if (val === '部门管理') {
        var query = { type: '2' }
        this.$router.push({
          path: '/admin/organization',
          query,
        })
      } else if (val === '系统公告') {
        var query = { type: '3' }
        this.$router.push({
          path: '/admin/organization',
          query, 
        })
      } else if (val === '项目统计') {
        this.$router.push({
           
          path: '/admin/statistics',
          query: {
            tab: '1',
          },
        })
      } else if (val === '业务考核') {
        this.$router.push({
          path: '/admin/statistics',
          query: {
            tab: '2',
          },
        })
      } 
    },
    // 点击设置
    settingClick() {
      this.isSettingShow = true
    },
    goEditUserInfo(val) {
      this.$router.push({
        path: '/join/edit',
        query: {
          type: val,
        },
      })
      this.tabsCurrent = ''
    },
    // 点击头像
    headerClick() {
      this.isSelectShow = true
    },
    handleIndexTabsClick(val) {
      if (val == '6') return
      this.tabsCurrent = val
      if (val == '1') {
        this.$router.push('/index/home')
      }
      if (val == '2') {
        this.$router.push('/project')
      }
      if (val == '4') {
        this.$router.push('/clientManage')
      }
      if (val == '5') {
        this.$router.push('/knowledge')
      }
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.avatarUrl = localStorage.getItem('btlh_process_avatarUrl') || ''
    this.my_process_avatarUrl =
      localStorage.getItem('btlh_process_avatarUrl') || ''
    this.my_nickname = localStorage.getItem('btlh_process_nickname') || ''
    // alert(this.my_nickname)
    this.my_company_logo =
      localStorage.getItem('bthl_process_LoginCompanyLoGo') || ''
    this.my_company_name =
      localStorage.getItem('bthl_process_LoginCompanyName') || ''
  },
  mounted() {
    let that = this
    document.addEventListener('click', function (e) {
      if (e.target.className == 'header') return
      if (e.target.parentNode.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.parentNode.className !=
            'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else {
        if (e.target.className != 'headerSlid') {
          that.isSelectShow = false
        }
      }
    })
    document.addEventListener('click', function (e) {
      if (e.target.className == 'logo_setting') return
      if (e.target.parentNode.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.className !=
            'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.parentNode.className !=
            'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode.parentNode.parentNode) {
        console.log(
          'e.target.parentNode.parentNode.parentNode',
          e.target.parentNode.parentNode.parentNode.className
        )
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else {
        if (e.target.className != 'settingSlid') {
          that.isSettingShow = false
        }
      }
    })
  },
}
</script>
<style lang="less" scoped>
.index_header_box {
  position: relative;
  box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.04);
  height: 8%;
  background-color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    margin-left: 100px;
    img {
      width: 180px;
      margin-right: 125px;
    }
    // tab
    .index_tabs {
      display: flex;
      padding-top: 10px;
      li {
        cursor: pointer;
        white-space: nowrap;
        font-size: 18px;
        color: #666;
        margin-left: 50px;
        position: relative;
        .underLine {
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: #40a0f2;
        }
      }
      .indexTabsActive {
        color: #128bf1;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    margin-right: 100px;
    .logo_setting,
    .logo_fly,
    .logo_position {
      width: 25px;
      height: 25px;
      margin-left: 40px;
    }
    .header {
      margin-left: 40px;
      width: 48px;
      height: 48px;
      border-radius: 24px;
    }
  }
  // 头像下啦框
  .headerSlid {
    position: absolute;
    z-index: 5;
    top: 100%;
    right: 100px;
    width: 280px;
    height: 345px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    .headerInfor {
      border-radius: 5px 5px 0 0;
      height: 130px;
      background: url(../assets/image/headerSlid.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      .SlidLeft {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 50%;
        img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }
      }
      .SlidRight {
        .username {
          font-size: 18px;
          color: #ffffff;
          margin-top: 30px;
          margin-bottom: 15px;
        }
        .position {
          font-size: 16px;
          color: #fff;
        }
      }
    }
    // 操作栏
    .userHandle {
      height: calc(100% - 130px);
      padding: 0 20px;
      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 25%;
        font-size: 14px;
        color: #666;
        border-bottom: 1px dashed #f4f5f6;
        img {
          width: 21px;
          margin-left: 62px;
          margin-right: 10px;
        }
      }
      li:last-child {
        border-bottom: none;
      }
      li:hover {
        color: #333;
      }
    }
  }
  // 设置下拉框
  .settingSlid {
    position: absolute;
    z-index: 5;
    top: 100%;
    right: 188px;
    width: 200px;
    height: 180px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    ul {
      height: 100%;
      padding: 10px 20px;
      box-sizing: border-box;
      li {
        height: 33%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        border-bottom: 1px dashed #f4f5f6;
      }
      li:last-child {
        border-bottom: none;
      }
      li:hover {
        color: #333;
      }
    }
  }
}
// 修改下拉
.el-dropdown-menu {
  top: 8% !important;
  margin-top: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  /deep/.popper__arrow {
    transform: translateX(-300px);
  }
  transform: translateX(300px);
  // 修改箭头
  // /deep/.popper__arrow {
  //   border-bottom-color: #fff !important;
  //   // border-bottom-width: 20px;
  //   width: 1px;
  //   top: -30px;
  //   border-width: 15px;
  // }
  // 修改箭头
}

.drop_container {
  box-sizing: border-box;
  width: 360px !important;
  padding: 0 40px;
  padding-top: 15px;
}

.adminItem {
  width: 100%;
  .adminTitle {
    font-size: 16px;
    color: #128bf1;
    cursor: default;
    display: flex;
    align-items: center;
  }
  .itemsContainer {
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    li {
      font: 14px sans-serif;
      cursor: pointer;
      color: #666;
    }
    li:hover {
      color: #333;
    }
  }
  .adminTitle::before {
    content: '';
    display: block;
    width: 2px;
    height: 14px;
    background: #40a0f2;
    margin-right: 10px;
  }
}
</style>
